import { Stack } from "@mui/material";
import AADatasetSelectionBtn from "src/views/assistant/components/AADatasetSelectionBtn";

type AAChatInputBarProps = {
  isInputting?: boolean;
  isChatLoading?: boolean;
  isGenerating?: boolean;
  handleFormSubmit?: (event: React.FormEvent | React.KeyboardEvent) => void;
  onStopChat?: () => void;
};

const AAChatInputBar = ({}: AAChatInputBarProps) => {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-end"
      sx={{ width: "100%" }}
      gap={2}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        width="100%"
        gap={1}
      >
        <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
          <AADatasetSelectionBtn />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default AAChatInputBar;
